import { useParams, useNavigate } from "react-router-dom";
import { BlogCardAnimation } from "../BlogCardAnimation/BlogCardAnimation";
import { useDispatchedActions } from "../../../../hooks";
import { errorToast } from "../../../../utils/helpers/customToast.helper";
import { ApiService } from "../../../../services/ApiService";
import "./BlogCard.scss";

export const formatDateToBlogView = (lang, dateIsoString) => {
  const date = new Date(dateIsoString);

  const options = {
    year: "numeric",
    month: "long",
    day: "numeric"
  };

  return date.toLocaleDateString(lang, options);
};

export const BlogCard = ({ title, date, color, tag }) => {
  const { lang } = useParams();
  const navigate = useNavigate();

  const { setBlogArticle } = useDispatchedActions();

  const handleClick = async () => {
    try {
      const { data, status } = await ApiService.getBlogArticle(lang, tag);

      if (status !== 200) throw new Error("test");

      setBlogArticle(data);
      navigate(`/${lang}/blog/${tag}`);
    } catch (e) {
      errorToast("Something went wrong", lang);
    }
  };

  return (
    <div className={`blog-card blog-card--${color}`} onClick={handleClick}>
      <div className="blog-card__animation">
        <BlogCardAnimation color={color} />
      </div>
      <div className="blog-card__content">
        <div className="blog-card__title">{title}</div>
        <div className="blog-card__date">{formatDateToBlogView(lang, date)}</div>
      </div>
    </div>
  );
};

